import { create } from "zustand";

type LoadingStore = {
  loadingMap: Record<string, boolean>;
  startLoading: (id: string) => void;
  endLoading: (id: string) => void;
  isLoading: boolean;
};

export const useLoadingStore = create<LoadingStore>((set, get) => ({
  loadingMap: {},
  startLoading: (id: string) =>
    set((state) => ({
      loadingMap: { ...state.loadingMap, [id]: true },
    })),
  endLoading: (id: string) =>
    set((state) => {
      const newMap = { ...state.loadingMap };
      delete newMap[id];
      return { loadingMap: newMap };
    }),
  get isLoading() {
    return Object.keys(get().loadingMap).length > 0;
  },
}));
